import { useEffect, useState } from 'react'
import { ModalStore } from '../../state/ModalStore'
import UserUploadsComponent from '../UserUploadsComponent'
// import CancelButton from '../Buttons/CancelButton'
// import { Primary } from '../Buttons/Primary'
import ErrorAlert from '../Alerts/ErrorAlert'
// import { CustomerAPI, CustomerFetcher } from '../../apis/CustomerAPI'
// import useSWR from 'swr'
import ModalContent from './ModalContent'
import ModalContentWrapper from './ModalContentWrapper'
import ModalHeader from './ModalHeader'
import ModalFooter from './ModalFooter'
import ModalMainWrapper from './ModalMainWrapper'

export default function SelectDesignModal({
    setValue,
    getValues,
    afterSelection,
    item,
}) {
    const skimModal = ModalStore((state) => state.skim)

    const [error, setError] = useState(null)
    const [prevSelected, setPrevSelected] = useState([])

    // const { data: customer, error: customerError } = useSWR(
    //     CustomerAPI.getCustomer,
    //     CustomerFetcher,
    // )

    const onSelect = (url) => {
        setValue(item.name, url)
    }

    const onChooseDesign = () => {
        const value = getValues(item.name)
        const isValidValue = value && value?.length !== 0 && value != null

        if (!isValidValue) {
            setError('Please select a design.')
            return
        } else {
            afterSelection(value)
            setError(null)
            skimModal()
        }
    }

    const handleCancel = () => {
        setValue(item.name, prevSelected)
        skimModal()
    }

    useEffect(() => {
        setPrevSelected(getValues(item.name))
    }, [])

    return (
        <ModalMainWrapper>
            <ModalContentWrapper size="5xl">
                <ModalHeader title={'Select Design Files'} />
                <ModalContent spacing="normal" scroll={true}>
                    <UserUploadsComponent
                        noOfColumns={4}
                        canUpload={true}
                        canSelect={true}
                        onSelect={onSelect}
                        selected={getValues(item.name)}
                        showTitle={true}
                    />
                    {error && <ErrorAlert error={error} />}
                </ModalContent>

                <ModalFooter
                    onCancel={handleCancel}
                    confirmText="Select Files"
                    onConfirm={onChooseDesign}
                />

                {/* {!customer && customerError && (
                                        <div className="flex justify-between mt-4 ">
                                            Please login to use this feature.
                                        </div>
                                    )} */}
            </ModalContentWrapper>
        </ModalMainWrapper>
    )
}
